<template>
    <div class="hall-list-wrapper">
        <ul>
            <li class="hall-item" v-for="item in list" :key="item.url" @click="handleClick(item)">
                <img class="img-item" :src="require(`@/assets/ccbn/${item.url}`)"/>
            </li>
        </ul>
        <van-overlay :show="visible" @click="visible = false">
            <div class="wrapper">
                <div class="block" ref="overlayImgRef">
                    <img class="img" :src="require(`@/assets/ccbn/overlay/${currentImg}`)" />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: 'ccbn-hallList',
    data() {
        return {
            visible: false,
            currentImg: '1A.jpg',
            list: [
                {
                    url: '1A.jpg'
                },{
                    url: '1B.jpg'
                },{
                    url: '2B.jpg'
                },{
                    url: '2.jpg'
                },{
                    url: '3.jpg'
                },{
                    url: '4.jpg'
                },{
                    url: '5.jpg'
                },{
                    url: '6.jpg'
                },{
                    url: '7.jpg'
                },{
                    url: '8A.jpg'
                },{
                    url: '8B.jpg'
                },{
                    url: 'external.jpg'
                }
            ]
        }
    },
    mounted() {
        this.ele = this.$refs.overlayImgRef
        this.ele.addEventListener('touchstart', this.touchStart)
        this.ele.addEventListener('touchmove', this.touchMove)
        this.ele.addEventListener('touchend', this.touchEnd)
    },
    methods: {
        handleClick(item) {
            this.visible = true
            this.currentImg = item.url

            this.ele.style.transform = ''
        },
        touchStart(e) {
            e.preventDefault();
            this.start = [];
            this.istouch = false;
            if (e.touches.length >= 2) {
                this.istouch = true
                this.start = e.touches
            } else if (e.touches.length === 1) {
                this.touches = {}
                this.istouch = true
                this.touches.pageX = e.touches[0].pageX
                this.touches.pageY = e.touches[0].pageY
            }
        },
        touchMove(e) {
            e.preventDefault();
            if (e.touches.length >= 2 && this.istouch) {
                let now = e.touches;
                let scale = this.getDistance(now[0], now[1]) / this.getDistance(this.start[0], this.start[1])
                this.scale = scale.toFixed(2);

                this.ele.style.transform = `scale(${this.scale})`
            } else if (e.touches.length === 1 && this.istouch) {
                let deltaX = e.touches[0].pageX - this.touches.pageX
                let deltaY = e.touches[0].pageY - this.touches.pageY

                this.ele.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${this.scale})`;
            }
        },
        touchEnd() {
            if (this.istouch) {
                this.istouch = false
            }
        },
        getDistance(p1, p2) {
            let x = p2.pageX - p1.pageX;
            let y = p2.pageY - p1.pageY;
            return Math.sqrt((x * x) + (y * y));
        },
        gesturemove() {
            this.ele.style.transform = `scale(${this.scale})`
        }
    },
    unmounted() {
        this.ele.removeEventListener('touchstart', this.touchStart)
        this.ele.removeEventListener('touchmove', this.touchMove)
        this.ele.removeEventListener('touchend', this.touchEnd)
    }
}
</script>

<style scoped>
.hall-list-wrapper {
    width: 100%;
}
.hall-list-wrapper .hall-item {
    width: 100%;
}
.hall-list-wrapper .hall-item .img-item {
    width: 100%;
}
.hall-list-wrapper .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.hall-list-wrapper .block {
    width: 80%;
    background-color: #fff;
    transform-origin: center center;
    transition: all .1s;
}
.hall-list-wrapper .block .img {
    width: 100%;
}
</style>